import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns';
import * as Locales from 'date-fns/locale';
import { TranslateService } from '@ngx-translate/core';

/**
 * Returns formatted date based on locale, if not supported by date-fns it uses custom
 * @param {date} value date to format
 * @param {any[]} args first index is the length of the formatted date, possible values:
 *  - P, eg: 04/01/1997
 *  - PP, eg: 04 jan 1997
 *  - PPP, eg: 4 January 1997
 *  - PPPP, eg: saturday 4 January 1997
 *
 *  second index is a boolean and if true it includes the time.
 */
@Pipe({ name: 'formatDate' })
export class FormatDatePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: Date, ...args: any[]) {
    if (!value) return '';
    const lang = this.translate.currentLang.split('-')[0];
    const length = `${args[0]}${args[1] ? 'p' : ''}`;
    return format(new Date(value), length, { locale: Locales[lang] });
  }
}
